<template>

    <div id="principal">
        <input id="ruta-visor" style="background-color:black;width:100%" />
        <!-- <div v-if="!Cargando" class="cargando">
            <figure class="text-center mb-5 mx-5">
                <img class="imagen"  src="/static/img/logo-pj-transparente-blanco.7f73976.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"></figure>
            <h3 class="w-100">PROCESANDO INFORMACIÓN</h3> 
            <h4 class="w-100">ESPERE UN MOMENTO</h4> 
            <div class="w-100 mb-5 justify-content-center text-center position-relative d-flex">
            <i  class="fas fa-spinner fa-spin fa-5x" style="left: 0px; right: 0px;"></i>
             </div>
        </div> -->

        
        
        <div class="contenedor-visor">
<div class="arrow">

 
 <div class="contenedor-opciones">
     


     
     <button v-if="conCopiarlink" class="btn btn-light" id="copiar" @click="CopiarLinkArchivo(url)" title="ejemplo">
        <span class="fas fa-link fa-1x" >&nbsp;&nbsp;<font class="opcion" >Copiar Link</font></span></button>
     <button v-if="conDescarga" class="btn btn-light" @click="DescargarArchivo(url)">
        <span class="fas fa-file-download fa-1x" >&nbsp;&nbsp;<font class="opcion">Descargar</font></span></button>
          <button v-if="conImprimir" class="btn btn-light" @click="Imprimir()">
        <span class="fas fa-print fa-1x" >&nbsp;&nbsp;<font class="opcion" >Imprimir</font></span></button>

<div id="alert-copiado" class="alert alert-success" role="alert">
    <div> Link Copiado !!!</div>
</div>
   </div>


<div class="cambio-paginas">
         <span v-if="porPaginas"
          @click="cambiaPaginaPdf(0)"
          class="fas fa-backward fa-2x"
          :class="{ grey: numeroPagina == 1 }"
          >&nbsp;&nbsp;</span> 
        <span  v-if="porPaginas" class="paginas" >Página &nbsp;{{ numeroPagina }} &nbsp;De&nbsp; {{ totalPaginas }}</span> 
        <span  v-if="!porPaginas" class="paginas" >Total Páginas&nbsp;&nbsp;&nbsp; {{ totalPaginas }}</span>
         &nbsp;&nbsp;&nbsp;
      <span v-if="porPaginas"
          @click="cambiaPaginaPdf(1)"
          class="fas fa-forward fa-2x"
          :class="{ grey: numeroPagina == totalPaginas }"
          >&nbsp;&nbsp;</span> 
        
        &nbsp;&nbsp;&nbsp;&nbsp;

        <span
          style="float :right;padding-right:40px;font-size: 20px;color: #8c8e92;cursor: pointer;"
          @click="close"
          ><i class="el-icon-close"></i
        ></span>

        </div>
      </div>
      
                <pdf v-if="porPaginas" ref="pdf"            
                :src="'data:application/pdf;base64,'+urlPdf"
                :page="numeroPagina" 
                @num-pages="totalPaginas = $event"
                @page-loaded="numeroPagina = $event"
                @loaded="cargaPrimerPagina"       
                style="display: inline-block; width: 100%"></pdf>
                
      <div v-if="!porPaginas">
           <pdf  ref="pdf"
                v-for="i in numPages"
                :key="i"
                :src="'data:application/pdf;base64,'+urlPdf"
                :page="i" 
                @num-pages="totalPaginas = $event"
                @page-loaded="numeroPagina = $event"
                @loaded="cargaPrimerPagina"        
                style="display: inline-block; width: 100%"></pdf>
        </div>
            
        </div>
    </div>


</template>
<script>
import pdf from 'vue-pdf'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
    props: {
        url: {
            type: String,
            default: null
        },
        porPaginas:Boolean,
        conImprimir:Boolean,
        conDescarga:Boolean,
        conCopiarlink:Boolean
    },
    components: {
        pdf: pdf
    },
    data() {
        return {
            paginasCargadas:0,
            numPages: 1,
            urlPdf: null,
             filesProps: {
      },
      Cargando: false,
      numeroPagina: 0, 
      totalPaginas: 0, 
      RUTA_VISOR: '/Ver/url?file=',
      TIPO_ARCHIVO:".pdf",
      SERVIDOR_LOCAL:'\\\\themisfs',
        }
    },
    errorCaptured: function (err, vm, info) {
        console.log("error:::",err)
    },  

    methods: {

DescargarArchivo: function(rutaArchivo) {
          let target =false;
          let href = false;
          var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (target) ? "_blank" : '';
            a.href = (href) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
  
 },
    CopiarLinkArchivo:function(row){
            
        var id="ruta-visor"
        var existsTextarea = document.getElementById("ruta-visor"); 
         var rutaDescarga = row;
         rutaDescarga=this.$root.$el.baseURI.replace(this.$route.path,this.RUTA_VISOR+rutaDescarga)
        existsTextarea.value = encodeURI(rutaDescarga);
        existsTextarea.select();
 try {
        var status = document.execCommand('copy');
        if(!status){
            console.error("No se pudo copiar el texto");
        }else{
            $('#alert-copiado').show();
            setTimeout(function() {
              $("#alert-copiado").fadeOut(500);
            },1500);
            
            console.log("El texto ahora está en el portapapeles");
        }
    } catch (err) {
        console.log('No se pudo copiar');
    }
        },



   Imprimir($event){
   //    console.log("imprimir:::",this.$refs)
        if(this.porPaginas) this.$refs.pdf.print()
        else this.$refs.pdf[1].print()
     },
    cambiaPaginaPdf(val) {
      if (val === 0 && this.numeroPagina > 1) {
        this.numeroPagina --;
      }
      if (val === 1 && this.numeroPagina < this.totalPaginas) {
        this.numeroPagina++;
      }
    },
   
    cargaPrimerPagina($event) {
      //  console.log("eventooo:",$event)
       this.paginasCargadas ++
      // console.log("eventoooddddddddddddd:", this.paginasCargadas)
       let tiempo = (this.porPaginas==true)?100:(this.totalPaginas*60);
     if(this.paginasCargadas == this.totalPaginas || this.porPaginas) setTimeout(this.tiempoParaCargar,tiempo)
      this.numeroPagina = 1; 
    },

    tiempoParaCargar(){
       this.Cargando=true;
    },

    handleOpen() {
    //    console.log("Handle ")
      this.Cargando = true;
    },

    close() {
      this.Cargando = false;
    },

    Base64ABlob :function (b64Data, contentType='', sliceSize=512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
},

    ObtenerPdf: function (){ 
            let peticionAPI = {
                RutaDelArchivo: this.url
            };
            console.log("Peticion API:::",peticionAPI)          
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            axios.post(api.conexion + api.Comun.funcion.ObtenerPdf, peticionAPI,headerPeticion)
                    .then(respuesta => {             
                        if (respuesta.status != 200) {
                           // console.log("respuesta:::",respuesta);
                            let mensajeError = respuesta.data.Error.Mensaje;
                        //    console.log(mensajeError);
                        } else { 
                           // console.log("respuestaqwq   wqwqw:::",respuesta);
                           // var blob = new Blob([respuesta.data], {type: 'application/pdf'});
                            this.urlPdf = respuesta.data; //URL.createObjectURL(blob);
                           
                            const blob = this.Base64ABlob( this.urlPdf, 'application/pdf');
                            const blobUrl = URL.createObjectURL(blob);
                            //console.log("blobUrl----::",blobUrl)

                             let valor = pdf.createLoadingTask(blobUrl);
                             //console.log("valor::",valor)
                             valor.promise.then(pdf => {
                                 this.numPages = pdf.numPages;
                               //  console.log("pdfff::",this.numPages )
                             });
                          // respuesta.data.promise.then(pdf => {
                          //  this.numPages = pdf.numPages;
                          //  console.log("pdfff::",pdf)
                          // });
                         // console.log("pdfff::",pdf.numPages)
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                    }
            );
          
        },
        
    },
    created() {
        this.ObtenerPdf();
    
    }
}
</script>
<style scoped>
#alert-copiado{
    margin-top: .3em;
    width: fit-content;
    display: none;
}
.cambio-paginas{
    align-content: center;
  
}
.opcion{
     font-family:Myriad;
     font-size: 20px;
}
.contenedor-opciones{
    right: 1vh;
    top: 1em;
    height: 4em;
    z-index: 5;
    margin-left: 1vh;
    text-align: center;
    position: absolute;
}
.imagen{
    width: 60%;
}
.cargando{
    background-color: black;
    z-index: 10;
        top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    text-align: center;
    opacity: .8;
}
.paginas{
    color: white;
    font-size: 2em;
}
.currentPage {
    cursor: pointer;
    color: #8c8e92;
}

.currentPage:hover {
    color: #2761ff;
}
.arrow{
    position: -webkit-sticky !important;
    position: sticky;
    top: 0px;
    left :0px;
    z-index: 3;
    width: 100%;
    background-color: 	rgb(93,93, 93,1);
    padding: 12px 0;
    margin: 0;
    text-align :center;
}
 .el-dialog_body {
    color: #606266;
    font-size: 14px;
    padding:0;
}

.contenedor-visor {
    background-color: black;
    width: 100%;
 
}
.btn-descargar{
    position: relative;
}
.flotante {
    display:scroll;
        position:fixed;
        bottom:320px;
        right:0px;
}

@media only screen and (min-width : 10px) and (max-width : 900px) {
    .cambio-paginas{
          position: relative;
    width: fit-content;
    font-size: 1em;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Comunes/VisorPDFV2.vue